export default "/images/loading.gif?1155fc46d21638141d05a2c0f18dfa9d";